(function($) {

    $('.form--float-labels').formFloatLabels();

}(jQuery));